import React, { useEffect } from 'react';
import ReactDom from 'react-dom';
import FullScreenModal from './FullScreenModal';

export default function OverlayWrapper(props) {
    const container = document.getElementById('xs-modal-container');
    let overlayContainer = null;

    useEffect(() => {
        return () => {
            if (overlayContainer != null) {
                overlayContainer.remove();
            }
        };
    }, []);

    if (container == null) {
        return null;
    }

    overlayContainer = container.querySelector(`#${props.id}`);
    if (overlayContainer == null) {
        overlayContainer = document.createElement('div');
        overlayContainer.id = props.id;
        container.append(overlayContainer);
    }

    return ReactDom.createPortal(
        <FullScreenModal>
            {props.children}
        </FullScreenModal>
    , overlayContainer);
}
